const tableAssetStateKeys = Object.freeze({
  NO_STATE: 'NoState',
  DESCRIPTION: 'No Status Selected',
});

export default tableAssetStateKeys;
